export function assetUrl(path) {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const normalized = path.startsWith("/") ? path : `/${path}`;

  return encodeURI(`${base}${normalized}`);
}
